import {defineStore} from "pinia";
import {CacheStoreState} from "@/types/Stores/CacheStoreState";
import {Storage} from "@ionic/storage";
import IUserCache from "@/types/Models/Account/IUserCache";
import {IToDoTask} from "@/types/Models/Modules/Aufgabenplanung/IToDoTask";

export const useCacheStore = defineStore({
    id: "cacheStore",
    state: () => ({
        taskCache: null,
        /*----- persistent storage -----*/
        storage: new Storage({storeName: "cacheStore"}),
    }) as CacheStoreState<IToDoTask>,
    getters: {
        activeTaskCache: (state) => state.taskCache as IUserCache<IToDoTask> | null,
    },
    actions: {
        async init() {
            await this.storage.create();
            const taskCache = await this.storage.get("task-cache");
            if (taskCache) {
                this.taskCache = taskCache;

            }
        },
        async setTaskCache(cache: IUserCache<IToDoTask>) {
            this.taskCache = cache;
            await this.storage.set("task-cache", cache);
        },
        async clearStorage(): Promise<void> {
            await this.storage.clear();
            this.taskCache = null;
        },
    },
});